module.exports = __webpack_public_path__ + "static/media/rs_image.d577e879.svg";